import React from "react";
import { Checkbox } from "@material-ui/core/";
import md5 from 'md5';

export default (value, tableMeta, updateValue, itensTableSelected, handlerClickCheckbox) => {
    
    let check = -1;
    let checked = false;

    if (itensTableSelected.length > 0 && value != null) {
        const newItensTableSelected = itensTableSelected.map(item => {
            delete item.CONFIRM_AGENDAMENTO;
            return item;
        })
        
        check = newItensTableSelected
        .findIndex(item => JSON.stringify(item) === JSON.stringify(value));
    }

    if (check > -1) {
        checked = true;
    }

    return (
        <div align="center">
            <Checkbox
                edge="start"
                tabIndex={-1}
                disableRipple
                checked={checked}
                onClick={()=>{handlerClickCheckbox(value)}}
            />
        </div>
    );
};